import axios from 'axios';
import { PostcardActionsEventT } from 'src/entity/Analitic';
import { INominationsResponce, PostVoteT } from 'src/entity/Pretendents';
import { IPostSecondStageVotes } from 'src/features/postSecondStageVotes';

import bridge from '@vkontakte/vk-bridge';

export const MAIN_URL = 'https://www.karusel-tv.ru/glavgeroi-app';
export const POST_URL = 'https://gg2023.karusel-tv.ru/save.php';
export const POST_POSTCARD_URL = 'https://gg2023.karusel-tv.ru/image.php';
export const ANALITIC_API = 'event-tracking.json';
export const VK_WALL_UPLOAD_URL = 'vk-wall-upload.json';
export const GET_SECOND_STAGE_PRETENDENTS = 'nominants.json';
export const SEND_FIRST_STAGE_VOICES_EP = '/posts';
export const SEND_SEC_STAGE_VOICES_EP = '/posts';
export const GET_NOMINATIONS = 'nominations.json';
export const POST_SECONDSTAGE_VOTES = 'vote.json';

export const api = {
  getNominations: async () => {
    try {
      const { data } = await axios.get<INominationsResponce[]>(`${MAIN_URL}/${GET_NOMINATIONS}`);
      return data;
    } catch (error) {
      throw new Error('Произошла ошибка, попробуйте немного позже');
    }
  },
  getSecondStagePretendents: async () => {
    try {
      const { data } = await axios.get<INominationsResponce[]>(`${MAIN_URL}/${GET_SECOND_STAGE_PRETENDENTS}`);
      return data;
    } catch (error) {
      throw new Error('Произошла ошибка, попробуйте немного позже');
    }
  },
  postFirstStageVotes: (firstStageVotes: PostVoteT) => axios.post(`${POST_URL}`, firstStageVotes),
  postPostCard: (form: FormData) => axios.post(`${POST_POSTCARD_URL}`, form),
  sendPostCardActionEvent: async (type: PostcardActionsEventT) => {
    try {
      const { data } = await axios.get(`${MAIN_URL}/${ANALITIC_API}?type=${type}`);
      if (!data.success) {
        throw new Error('Произошла ошибка, попробуйте немного позже');
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },
  postSharePostCardData: async (form: FormData) => {
    try {
      const { data } = await axios.post(`${MAIN_URL}/${VK_WALL_UPLOAD_URL}`, form, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return data;
    } catch (error) {
      throw new Error(String(error));
    }
  },
  postSecondStageVotes: async (secondStageVotes: IPostSecondStageVotes) => {
    try {
      let nomin: any[] = [];
      let proj: any[] = [];
      // @ts-ignore
      const votes = Object.entries(secondStageVotes.votes);
      const dataVotes = votes.forEach(item => {
        nomin.push(item[0]);
        proj.push(item[1]);
      });
      nomin = { ...nomin };
      proj = { ...proj };

      // @ts-ignore
      bridge.send('VKWebAppSendCustomEvent', {
        event: 'cast_vote_click',
        screen: 'postSecondStageVotes',
        json: JSON.stringify({
          nominations_num: votes.length,
          nominations: nomin,
          projects: proj
        })

      });

      const { data } = await axios.post(
        `${MAIN_URL}/${POST_SECONDSTAGE_VOTES}`,
        JSON.stringify(secondStageVotes)
      );
      if (!data.success) {
        throw new Error('Произошла ошибка, попробуйте немного позже');
      }
    } catch (error) {
      throw new Error(String(error));
    }
  }
};
